import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/analytics";

/**
 * Mounts inside <BrowserRouter>. Fires a GA4 page_view on every route change.
 * SPA-friendly: relies on react-router's location, not the initial document load.
 * Debounced by 50ms so the title (set by <SEO />) is up-to-date.
 */
export const AnalyticsRouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    const id = window.setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 80);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);
  return null;
};

export default AnalyticsRouteTracker;
